var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreelancing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 210,
    fill: "none",
    viewBox: "0 0 228 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M145.003 78.052a42.483 42.483 0 0 1 3.516-13.408 42.245 42.245 0 0 1 1.747-3.467.259.259 0 0 0-.447-.261 43.062 43.062 0 0 0-5.333 17.136c-.031.331.487.329.517 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M151.519 62.005a3.277 3.277 0 1 0 0-6.554 3.277 3.277 0 0 0 0 6.554Zm-6.182 16.133a27.569 27.569 0 0 1 2.28-8.698c.344-.766.721-1.516 1.134-2.249a.175.175 0 0 0 .014-.125.17.17 0 0 0-.202-.118.168.168 0 0 0-.102.074 27.938 27.938 0 0 0-3.46 11.116c-.02.215.316.214.336 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M149.563 67.728a2.125 2.125 0 1 0 .001-4.25 2.125 2.125 0 0 0-.001 4.25Zm-4.649 10.21a27.547 27.547 0 0 1-4.041-10.732.168.168 0 0 0-.333.045 27.957 27.957 0 0 0 4.109 10.894c.117.181.381-.026.265-.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M140.54 67.58a2.126 2.126 0 1 0 0-4.252 2.126 2.126 0 0 0 0 4.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M138.391 79.818V75.64a1.565 1.565 0 0 1 1.566-1.567h9.747a1.57 1.57 0 0 1 1.566 1.567v4.177a1.569 1.569 0 0 1-1.566 1.566h-9.747a1.569 1.569 0 0 1-1.566-1.566Zm10.962-26.628h-4.177a1.565 1.565 0 0 1-1.567-1.567V34.566A1.57 1.57 0 0 1 145.176 33h4.177a1.57 1.57 0 0 1 1.566 1.566v17.057a1.565 1.565 0 0 1-1.566 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M150.743 36.307h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M159.798 53.19h-4.177a1.569 1.569 0 0 1-1.566-1.567V34.566A1.565 1.565 0 0 1 155.621 33h4.177a1.568 1.568 0 0 1 1.567 1.566v17.057a1.57 1.57 0 0 1-1.567 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M161.188 36.307h-6.961v1.392h6.961v-1.392Zm0 10.791h-6.961v1.392h6.961v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M170.236 53.19h-4.177a1.57 1.57 0 0 1-1.567-1.567V34.566A1.57 1.57 0 0 1 166.059 33h4.177a1.57 1.57 0 0 1 1.566 1.566v17.057a1.569 1.569 0 0 1-1.566 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M171.626 36.307h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M175.806 81.385h-4.177a1.567 1.567 0 0 1-1.567-1.567V62.762a1.57 1.57 0 0 1 1.567-1.567h4.177a1.57 1.57 0 0 1 1.566 1.567v17.056a1.564 1.564 0 0 1-1.566 1.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M177.196 64.502h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M186.251 81.385h-4.177a1.569 1.569 0 0 1-1.566-1.567V62.762a1.565 1.565 0 0 1 1.566-1.567h4.177a1.566 1.566 0 0 1 1.567 1.567v17.056a1.57 1.57 0 0 1-1.567 1.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M187.642 64.502h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M196.689 81.385h-4.177a1.565 1.565 0 0 1-1.567-1.567V62.762a1.57 1.57 0 0 1 1.567-1.567h4.177a1.57 1.57 0 0 1 1.566 1.567v17.056a1.564 1.564 0 0 1-1.566 1.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M198.087 64.502h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M148.306 109.58h-4.177a1.572 1.572 0 0 1-1.567-1.566V90.957a1.57 1.57 0 0 1 1.567-1.566h4.177a1.57 1.57 0 0 1 1.566 1.566v17.057a1.565 1.565 0 0 1-1.566 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M149.696 92.697h-6.962v1.393h6.962v-1.393Zm0 10.791h-6.962v1.393h6.962v-1.393Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M158.751 109.58h-4.177a1.565 1.565 0 0 1-1.566-1.566V90.957a1.565 1.565 0 0 1 1.566-1.566h4.177a1.566 1.566 0 0 1 1.567 1.566v17.057a1.57 1.57 0 0 1-1.567 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M160.142 92.697h-6.962v1.393h6.962v-1.393Zm0 10.791h-6.962v1.393h6.962v-1.393Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M169.197 109.58h-4.177a1.574 1.574 0 0 1-1.108-.459 1.574 1.574 0 0 1-.459-1.107V90.957a1.57 1.57 0 0 1 1.567-1.566h4.177a1.57 1.57 0 0 1 1.566 1.566v17.057a1.57 1.57 0 0 1-1.566 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M170.587 92.697h-6.962v1.393h6.962v-1.393Zm0 10.791h-6.962v1.393h6.962v-1.393Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M180.681 53.19h-4.177a1.567 1.567 0 0 1-1.566-1.567V34.566A1.565 1.565 0 0 1 176.504 33h4.177a1.57 1.57 0 0 1 1.566 1.566v17.057a1.565 1.565 0 0 1-1.566 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M182.071 36.307h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M191.126 53.19h-4.177a1.569 1.569 0 0 1-1.566-1.567V34.566A1.565 1.565 0 0 1 186.949 33h4.177a1.566 1.566 0 0 1 1.567 1.566v17.057a1.57 1.57 0 0 1-1.567 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M192.517 36.307h-6.962v1.392h6.962v-1.392Zm0 10.791h-6.962v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M201.564 53.19h-4.177a1.565 1.565 0 0 1-1.567-1.567V34.566A1.57 1.57 0 0 1 197.387 33h4.177a1.57 1.57 0 0 1 1.566 1.566v17.057a1.565 1.565 0 0 1-1.566 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M202.962 36.307H196v1.392h6.962v-1.392Zm0 10.791H196v1.392h6.962v-1.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M212.009 53.19h-4.177a1.569 1.569 0 0 1-1.566-1.567V34.566A1.565 1.565 0 0 1 207.832 33h4.177a1.568 1.568 0 0 1 1.567 1.566v17.057a1.57 1.57 0 0 1-1.567 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M213.399 36.307h-6.961v1.392h6.961v-1.392Zm0 10.791h-6.961v1.392h6.961v-1.392Zm14.257 6.614H128.45a.346.346 0 0 1-.348-.348.346.346 0 0 1 .348-.348h99.206a.348.348 0 0 1 0 .696Zm0 28.195H128.45a.346.346 0 0 1-.348-.348.346.346 0 0 1 .348-.348h99.206a.348.348 0 0 1 0 .696Zm0 28.195H128.45a.343.343 0 0 1-.246-.102.345.345 0 0 1 0-.492.347.347 0 0 1 .246-.102h99.206a.35.35 0 0 1 .246.594.345.345 0 0 1-.246.102Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M202.441 106.247a42.454 42.454 0 0 1 5.262-16.875.26.26 0 0 0-.447-.261 43.063 43.063 0 0 0-5.333 17.136c-.03.331.487.329.518 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M208.957 90.2a3.277 3.277 0 1 0 0-6.553 3.277 3.277 0 0 0 0 6.554Zm-6.183 16.134a27.572 27.572 0 0 1 3.414-10.948.167.167 0 0 0-.187-.243.17.17 0 0 0-.103.074 27.964 27.964 0 0 0-3.46 11.117c-.02.215.316.213.336 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M207.001 95.924a2.126 2.126 0 1 0 0-4.252 2.126 2.126 0 0 0 0 4.252Zm-4.649 10.209a27.538 27.538 0 0 1-4.042-10.731.167.167 0 0 0-.188-.139.168.168 0 0 0-.145.183 27.963 27.963 0 0 0 2.824 8.676c.395.758.823 1.498 1.286 2.218.116.182.38-.026.265-.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M197.97 95.775a2.126 2.126 0 1 0 0-4.252 2.126 2.126 0 0 0 0 4.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M195.82 108.013v-4.177a1.569 1.569 0 0 1 1.567-1.566h9.746a1.569 1.569 0 0 1 1.567 1.566v4.177a1.57 1.57 0 0 1-1.567 1.566h-9.746a1.57 1.57 0 0 1-1.567-1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M132.971 159.532H.348a.35.35 0 0 1-.348-.348.348.348 0 0 1 .348-.348h132.623a.35.35 0 0 1 .246.594.35.35 0 0 1-.246.102Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M69.29 113.932a9.399 9.399 0 1 0-.001-18.797 9.399 9.399 0 0 0 0 18.797Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "m60.358 164.865-.249-4.259 16.314-2.989.368 6.288-16.433.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "m61.154 157.492.48 8.216-5.173.302-.783-13.389a5.182 5.182 0 0 1 5.476 4.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "m67.458 164.827-2.71 3.297-14.006-8.883 4-4.866 12.716 10.452Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "m61.868 169.704 5.226-6.358 4.004 3.29-8.517 10.361a5.182 5.182 0 0 1-.713-7.293Zm-2.212-20.208-1.852 8.73a1.394 1.394 0 0 0 1.34 1.681l18.204.293a1.387 1.387 0 0 0 1.394-1.634l-1.593-9.023a1.396 1.396 0 0 0-1.371-1.15h-14.76a1.391 1.391 0 0 0-1.362 1.103Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M62.677 152.569s-17.753-11.139-21.234-5.221c-1.74 2.959-.87 5.83.436 7.962a12.054 12.054 0 0 0 5.013 4.488l14.393 7.043 5.221-5.569-3.48-3.133-.349-5.57Zm9.048-1.739s22.974-6.614 18.449 5.918c-4.526 12.531-21.582 7.658-21.582 7.658l-1.74-5.222 5.917-4.177-1.044-4.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M69.409 115.228a8.55 8.55 0 1 0 0-17.1 8.55 8.55 0 0 0 0 17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M69.856 152.211a45.915 45.915 0 0 1-10.532-1.387l-.102-.028-4.771-21.946a8.084 8.084 0 0 1 5.198-9.378 28.004 28.004 0 0 1 17.857-.357 8.172 8.172 0 0 1 5.442 9.665l-5.328 21.997-.075.036c-2.215 1.049-4.984 1.398-7.69 1.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M63.45 153.915a3.505 3.505 0 0 1 2.088-2.101 3.497 3.497 0 0 1 2.95.252l9.394-8.154.85 6.408-9.05 6.761a3.52 3.52 0 0 1-6.232-3.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M72.41 155.693c-.153 0-.305-.023-.451-.066a1.554 1.554 0 0 1-1.031-.981l-1.134-3.212a1.557 1.557 0 0 1 .453-1.707l12.8-7.683L78 119.536l.128-.031c.052-.013 5.222-1.19 7.34 4.459 1.483 3.956 6.973 12.558 6.586 18.371a5.181 5.181 0 0 1-4.29 4.778l-14.406 8.255c-.272.21-.605.324-.949.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M73.845 153.151a3.503 3.503 0 0 0-3.591-2.302 3.494 3.494 0 0 0-1.448.453l-9.394-8.154-.85 6.408 9.051 6.761a3.521 3.521 0 0 0 4.522 1.185 3.517 3.517 0 0 0 1.71-4.351Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M65.83 155.693a1.55 1.55 0 0 1-.948-.325L49.43 147.81a5.186 5.186 0 0 1-4.29-4.779c-.387-5.813 6.147-15.111 7.63-19.067 2.118-5.649 7.288-4.472 7.34-4.459l.128.031-6.09 23.204 13.844 6.988a1.557 1.557 0 0 1 .453 1.706l-1.133 3.212a1.554 1.554 0 0 1-1.483 1.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M84.26 159.184H53.28a2.44 2.44 0 0 1-2.436-2.437v-17.056a2.442 2.442 0 0 1 2.436-2.437h30.98a2.442 2.442 0 0 1 2.437 2.437v17.056a2.44 2.44 0 0 1-2.437 2.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.768 150.306a2.089 2.089 0 1 0 0-4.177 2.089 2.089 0 0 0 0 4.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M60.776 106.331c-.507-1.285.325-2.817 1.558-3.439 1.233-.623 2.721-.504 4.04-.094 1.11.345 2.148.879 3.23 1.301a7.225 7.225 0 0 0 3.395.605c1.153-.131 2.302-.777 2.774-1.838.49-1.1.156-2.441-.597-3.38a6.544 6.544 0 0 0-2.998-1.926c-2.544-.896-5.482-.923-7.843.38-2.362 1.303-3.967 4.076-3.478 6.729"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M11.37 155.466a42.485 42.485 0 0 1 3.516-13.408 42.414 42.414 0 0 1 1.747-3.467.259.259 0 0 0-.447-.261 43.06 43.06 0 0 0-5.333 17.136c-.03.331.487.329.517 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M17.886 139.419a3.277 3.277 0 1 0 0-6.554 3.277 3.277 0 0 0 0 6.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M11.704 155.553a27.566 27.566 0 0 1 3.414-10.948.168.168 0 0 0-.29-.169 27.936 27.936 0 0 0-3.46 11.117c-.02.215.316.213.336 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M15.93 145.143a2.126 2.126 0 1 0 0-4.252 2.126 2.126 0 0 0 0 4.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M11.281 155.352A27.557 27.557 0 0 1 7.24 144.62a.168.168 0 0 0-.333.045 27.935 27.935 0 0 0 4.11 10.894c.116.181.38-.026.264-.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M6.907 144.994a2.126 2.126 0 1 0 0-4.252 2.126 2.126 0 0 0 0 4.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M4.758 157.232v-4.177a1.566 1.566 0 0 1 1.566-1.567h9.747a1.57 1.57 0 0 1 1.566 1.567v4.177a1.57 1.57 0 0 1-1.566 1.566H6.324a1.564 1.564 0 0 1-1.566-1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6584",
    d: "M109.439 162.108c0 2.289-1.856 3.33-4.145 3.33-2.29 0-4.146-1.041-4.146-3.33 0-2.29.922-4.961 4.146-4.04 3.224-1.382 4.145 1.75 4.145 4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M105.093 159.141a.666.666 0 0 1-.658-.578c-.137-1.142-.894-3.379-1.213-4.288a.6.6 0 0 1 .077-.545.607.607 0 0 1 .448-.242.627.627 0 0 1 .479.175.589.589 0 0 1 .163.444c-.063 1.166.788 3.051 1.3 4.071a.665.665 0 0 1-.596.963Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M108.166 156.568c1.439-1.177.31-3.588-1.491-3.125a1.453 1.453 0 0 0-.649.346c-1.105 1.044-1.276 3.714-1.276 3.714s1.951.264 3.416-.935Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 33h228v143.998H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancing);
export default __webpack_public_path__ + "static/media/freelancing.1cf27da3078e4bf5dc8c6a5f5269d046.svg";
export { ForwardRef as ReactComponent };